// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Legacy global helpers. These used to live in employees/Employees.css and applied app-wide
   only because that file happened to be imported everywhere. Kept global because many pages
   use them; don't add to this file — new styles belong to a scoped page class or tokens.
   ============================================================ */

.input-search .ant-btn-primary {
  background-color: var(--ds-brand-dark);
}

.mt-5 {
  margin-top: 1rem !important;
}

.page-header {
  margin-bottom: 5px !important;
}

.top-right-stuff {
  float: inline-end;
}

.ant-tabs-content-holder .top-right-stuff {
  float: none;
}

.success-title-message .ant-notification-notice-message {
  color: var(--ds-success, #389e0d) !important;
}

.warning-title-message .ant-notification-notice-message {
  color: var(--ds-warning, #d48806) !important;
}

.error-title-message .ant-notification-notice-message {
  color: var(--ds-danger) !important;
}

.modals-inputs-label {
  font-weight: normal !important;
}

.join-meeting-button-color {
  background-color: var(--ds-brand-dark);
}

.project-files-dragger .ant-form-item {
  margin-bottom: 0 !important;
}

.login-left {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.1), var(--ds-surface)) !important;
}

.full-width {
  width: 100%;
}

.user-menu.nav li a {
  padding-top: 6px !important;
}
`, "",{"version":3,"sources":["webpack://./src/design-system/legacy.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* ============================================================\n   Legacy global helpers. These used to live in employees/Employees.css and applied app-wide\n   only because that file happened to be imported everywhere. Kept global because many pages\n   use them; don't add to this file — new styles belong to a scoped page class or tokens.\n   ============================================================ */\n\n.input-search .ant-btn-primary {\n  background-color: var(--ds-brand-dark);\n}\n\n.mt-5 {\n  margin-top: 1rem !important;\n}\n\n.page-header {\n  margin-bottom: 5px !important;\n}\n\n.top-right-stuff {\n  float: inline-end;\n}\n\n.ant-tabs-content-holder .top-right-stuff {\n  float: none;\n}\n\n.success-title-message .ant-notification-notice-message {\n  color: var(--ds-success, #389e0d) !important;\n}\n\n.warning-title-message .ant-notification-notice-message {\n  color: var(--ds-warning, #d48806) !important;\n}\n\n.error-title-message .ant-notification-notice-message {\n  color: var(--ds-danger) !important;\n}\n\n.modals-inputs-label {\n  font-weight: normal !important;\n}\n\n.join-meeting-button-color {\n  background-color: var(--ds-brand-dark);\n}\n\n.project-files-dragger .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.login-left {\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.1), var(--ds-surface)) !important;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.user-menu.nav li a {\n  padding-top: 6px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
